import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {SimpleUser} from "./user.service";
import {Observable} from "rxjs";
import {Page} from "./api.service";
import {environment} from "../../environments/environment";
import {Assessment} from "./volunteer-task.service";
import { Subject } from './subject.service';

const FileSaver = require('file-saver');

export type AttendeeStatus = 'ACTIVE' | 'COMPLETED' | 'DELETED' ;

export interface Points {
  pointsEarned: number ;

  participationPointsOffered: number;
  participationPointsEarned: number;
  participationScore: number ;

  knowledgePointsOffered: number;
  knowledgePointsEarned: number;
  knowledgeScore: number ;
}

export class AttendeeKey {
  roomId: string ;
  userId: string ;

  constructor(roomId: string, userId: string) {
    this.roomId = roomId ;
    this.userId = userId ;
  }
}

export interface Attendee {
  id: AttendeeKey ;
  user: SimpleUser ;

  roomName: string ;
  roomRunBy: SimpleUser ;

  enrollmentId: string ;
  subjectId: string ;

  status: AttendeeStatus ;
  sandbox?: boolean ;
  points: Points ;

  joinedAt: Date ;
}


export class AttendeeQuery {

  subjectId?: string;
  userIds: string[];
  before?: Date ;
  after?: Date ;
  excludeSandbox: boolean ;

  public constructor() {
    this.userIds = [];
    this.excludeSandbox = false ;
  }
}


export interface PointExplanation extends Points {

  type: 'QUIZ' | 'CLASS_TASK' | 'VOLUNTEER_TASK' ;
  bonus: boolean ;
  adjustmentExplanation: string ;

  quizId: string ;
  questionIndex: number ;
  answered: boolean ;
  correct: boolean ;

  taskId: string ;
  subtaskIndex: number ;
  subtaskName: string ;
  completed: boolean ;
  optedIn: boolean ;
  assessment: Assessment ;
}

export interface PointEffect {
  points: number ;
  explanation: string ;
}

@Injectable({
  providedIn: 'root'
})
export class AttendeeService {

  constructor(private http: HttpClient) {

  }

  getAttendancesForEnrollment(enrollmentId: string, page:number): Observable<Page<Attendee>> {

    let params = {
      page: (page) ? page : 0
    }

    return this.http.get(
      `${environment.apiHost}/enrollments/${enrollmentId}/attendances`,
      {params}
    ) as Observable<Page<Attendee>>;
  }

  getAttendances(query: AttendeeQuery, page:number): Observable<Page<Attendee>> {

    let params = {
      q: JSON.stringify(query),
      page: (page) ? page : 0
    }

    return this.http.get(
      `${environment.apiHost}/attendances`,
      {params}
    ) as Observable<Page<Attendee>>;
  }

  getAttendeesForRoom(roomId: string, page: number): Observable<Page<Attendee>> {

    let params = {
      page: (page) ? page : 0
    }

    return this.http.get(
      `${environment.apiHost}/rooms/${roomId}/attendees`,
      { params }
    ) as Observable<Page<Attendee>>;
  }

  getAttendeeForRoom(roomId: string, userId: string): Observable<Attendee> {
    return this.http.get(
      `${environment.apiHost}/rooms/${roomId}/attendees/${userId}`
    ) as Observable<Attendee>;

  }

  getPointExplanations(roomId: string, userId: string | undefined): Observable<PointExplanation[]> {
    return this.http.get(
      `${environment.apiHost}/rooms/${roomId}/attendees/${(userId) ? userId: 'me'}/points`,
    ) as Observable<PointExplanation[]>;
  }

  
  exportAttendances(subject: Subject) {
    
    let filename = `attendances_${subject.code}.csv` ;
    
    this.http.get(
      `${environment.apiHost}/subjects/${subject.id!}/attendances.csv`,
      { responseType: 'blob'}
    ).subscribe(response => {
      FileSaver.saveAs(response, filename);
    }) ;

  }


}
